/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteFragment } from 'relay-runtime';
type AvailabilityCalendarContainer_viewer$ref = any;
type AvailabilityCheckerContainer_viewer$ref = any;
type EventSummaryContainer_viewer$ref = any;
import type { FragmentReference } from "relay-runtime";
declare export opaque type EventShowContainer_viewer$ref: FragmentReference;
export type EventShowContainer_viewer = {|
  +id: string,
  +past_referral_sources: ?$ReadOnlyArray<?string>,
  +c_templates: ?{|
    +edges: ?$ReadOnlyArray<?{|
      +node: ?{|
        +id: string,
        +title: ?string,
      |}
    |}>
  |},
  +form_templates: ?{|
    +edges: ?$ReadOnlyArray<?{|
      +node: ?{|
        +id: string,
        +title: ?string,
      |}
    |}>
  |},
  +mp_templates: ?{|
    +edges: ?$ReadOnlyArray<?{|
      +node: ?{|
        +id: string,
        +title: ?string,
      |}
    |}>
  |},
  +features: ?{|
    +music_lists: ?boolean
  |},
  +$fragmentRefs: EventSummaryContainer_viewer$ref & AvailabilityCheckerContainer_viewer$ref & AvailabilityCalendarContainer_viewer$ref,
  +$refType: EventShowContainer_viewer$ref,
|};
*/


const node/*: ConcreteFragment*/ = (function(){
var v0 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
},
v1 = [
  v0,
  {
    "kind": "ScalarField",
    "alias": null,
    "name": "title",
    "args": null,
    "storageKey": null
  }
];
return {
  "kind": "Fragment",
  "name": "EventShowContainer_viewer",
  "type": "User",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    v0,
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "past_referral_sources",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "c_templates",
      "storageKey": null,
      "args": null,
      "concreteType": "CTemplateConnection",
      "plural": false,
      "selections": [
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "edges",
          "storageKey": null,
          "args": null,
          "concreteType": "CTemplateEdge",
          "plural": true,
          "selections": [
            {
              "kind": "LinkedField",
              "alias": null,
              "name": "node",
              "storageKey": null,
              "args": null,
              "concreteType": "CTemplate",
              "plural": false,
              "selections": v1
            }
          ]
        }
      ]
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "form_templates",
      "storageKey": null,
      "args": null,
      "concreteType": "FormTemplateConnection",
      "plural": false,
      "selections": [
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "edges",
          "storageKey": null,
          "args": null,
          "concreteType": "FormTemplateEdge",
          "plural": true,
          "selections": [
            {
              "kind": "LinkedField",
              "alias": null,
              "name": "node",
              "storageKey": null,
              "args": null,
              "concreteType": "FormTemplate",
              "plural": false,
              "selections": v1
            }
          ]
        }
      ]
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "mp_templates",
      "storageKey": null,
      "args": null,
      "concreteType": "MpTemplateConnection",
      "plural": false,
      "selections": [
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "edges",
          "storageKey": null,
          "args": null,
          "concreteType": "MpTemplateEdge",
          "plural": true,
          "selections": [
            {
              "kind": "LinkedField",
              "alias": null,
              "name": "node",
              "storageKey": null,
              "args": null,
              "concreteType": "MpTemplate",
              "plural": false,
              "selections": v1
            }
          ]
        }
      ]
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "features",
      "storageKey": null,
      "args": null,
      "concreteType": "Features",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "music_lists",
          "args": null,
          "storageKey": null
        }
      ]
    },
    {
      "kind": "FragmentSpread",
      "name": "EventSummaryContainer_viewer",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "AvailabilityCheckerContainer_viewer",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "AvailabilityCalendarContainer_viewer",
      "args": null
    }
  ]
};
})();
// prettier-ignore
(node/*: any*/).hash = '75626512269a9c3a590894b56e796b22';
module.exports = node;



// WEBPACK FOOTER //
// ./webpack/components/Event/Show/__generated__/EventShowContainer_viewer.graphql.js